import * as React from 'react';
import {Container, Image} from './styles';
import logo from '../../../assets/icons/defaultAvatar.png';

interface Props {
  src?: string;
  size?: number;
}

const UserAvatar: React.FC<Props> = ({src = logo, size = 36}) => {
  return (
    <Container>
      <Image src={src} size={size} />
    </Container>
  );
};

export default UserAvatar;
